module.exports = __webpack_public_path__ + "assets/img/Lokyata-Landing-Page-+-Website-w720.ca4266ef.jpg";